import React from 'react'

export const Input = ({
    type = 'text',
    label = 'Name',
    fieldName = '',
    value = '',
    onChange = () => { },
    ...rest
}) => {
    return (
        <>
            <label>{label}</label>
            <input
                type={type}
                name={fieldName}
                value={value}
                onChange={onChange}
                {...rest}
            />
        </>
    )
}

export const TextArea = ({
    label = 'Name',
    fieldName = '',
    row = 10,
    cols = 10,
    value = '',
    onChange = () => { },
    ...rest
}) => {
    return (
        <>
            <label>{label}</label>
            <textarea
                rows={row}
                cols={cols}
                name={fieldName}
                value={value}
                onChange={onChange}
                {...rest}
            />
        </>
    )
}

